import {createSvgIcon} from "@mui/material";

export const VisibleIcon = createSvgIcon(
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.7501 7.50008C8.7501 8.46658 7.9666 9.25008 7.0001 9.25008C6.0336 9.25008 5.2501 8.46658 5.2501 7.50008C5.2501 6.53358 6.0336 5.75008 7.0001 5.75008C7.9666 5.75008 8.7501 6.53358 8.7501 7.50008Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7.00036 3.41675C4.38841 3.41675 2.17741 5.13343 1.43408 7.50006C2.1774 9.86672 4.38841 11.5834 7.00037 11.5834C9.61232 11.5834 11.8233 9.86674 12.5666 7.5001C11.8233 5.13345 9.61232 3.41675 7.00036 3.41675Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    'VisibleIcon'
)